import React from 'react';

import { CliveInsightsProvider } from '~/components/ClaimPage/CliveApp/CliveInsights/contexts/CliveInsightsProvider';

import { CliveInsightsView } from './CliveInsightsView';

interface CliveInsightsProps {
  /** The Automation First tab is shown for this claim and owns its actions, so this tab skips them. */
  areActionsInConductorHub?: boolean;
}

const CliveInsights: React.FC<CliveInsightsProps> = ({ areActionsInConductorHub = false }) => {
  return (
    <CliveInsightsProvider areActionsInConductorHub={areActionsInConductorHub}>
      <div className="flex h-full flex-col rounded p-8">
        <CliveInsightsView />
      </div>
    </CliveInsightsProvider>
  );
};

export default CliveInsights;
